import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import onWebviewClose from "../components/Button";
import Shield from "../components/Shield";
import InternalError from "../components/InternalError";
import LoadingBar from "../components/LoadingBar";
import queryString from "query-string";
import NoticeItems from "./NoticeItems";
import withStyles from "@mui/styles/withStyles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import "../css/notice.css";
import uploadLog from "../modules/uploadLog";
import { config } from "../config/config";
import axios from "axios";

const Container = styled.div`
  background-color: var(--bg-color);
  width: 100%;
  min-height: 100vh;
  color: var(--text-color_sub1);
`;

const CloseBtn = styled.button`
  font-size: 1.5rem;
  background-color: transparent;
  border: 0;
  position: absolute;
  top: 0;
  right: 0;
  outline: 0;
  padding: 0px;
`;

const styles = (theme) => ({
  offset: theme.mixins.toolbar,
});

const NoticeList = (props) => {
  const [header, setHeader] = useState("");
  const [notices, setNotices] = useState();
  const [errMsg, setErrMsg] = useState();

  // back: show the header close button on the list (home) view. Visible by
  // default; hidden only when the host explicitly passes `back=false`. The
  // hidden #backkeyTrigger (native back) stays regardless.
  const showClose =
    String(
      queryString.parse(props.location.search).back || "true",
    ).toLowerCase() !== "false";

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getHeader = () => {
    try {
      const params = queryString.parse(props.location.search);

      return fetch(
        "https://d11u2hwffcr0yq.cloudfront.net/" +
          process.env.REACT_APP_BUCKET_NAME +
          "/language-whatsnew.json",
      )
        .then((response) => response.json())
        .then((data) => {
          let language = params.language.substring(0, 2);
          if (language === "zh") {
            setHeader(
              data.webview[params.language.toLowerCase()]
                ? data.webview[params.language.toLowerCase()]
                : "What's New",
            );
          } else {
            setHeader(
              data.webview[language] ? data.webview[language] : "What's New",
            );
          }
        })
        .catch((err) => {
          setHeader("What's New");
        });
    } catch (err) {
      setHeader("What's New");
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const callApi = async () => {
    try {
      const UrlQueryStrings = props.location.search;
      const noticeData = await axios.get(
        process.env.REACT_APP_API_HOST + "notices" + UrlQueryStrings,
      );

      setNotices(noticeData.data);
    } catch (err) {
      setErrMsg(err.message);
    }
  };

  useEffect(() => {
    callApi();
    getHeader();
  }, []);

  const renderNotices = () => {
    try {
      const params = queryString.parse(props.location.search);
      const noticesData = notices.map((notices) => {
        return (
          <NoticeItems
            id={notices._id}
            key={notices._id}
            title={notices.title}
            subtitle={notices.subtitle}
            description={notices.description}
            files={notices.files}
            createdAt={`${notices.createdAt}`}
            publishedAt={
              notices.publishedAt
                ? `${notices.publishedAt}`
                : `${notices.createdAt}`
            }
            language={notices.language_code}
            important={notices.important}
            className={
              params.language &&
              (config.ARAB.indexOf(params.language) !== -1 ||
                config.ARAB.indexOf(params.language.split("-")[0]) !== -1)
                ? "textR"
                : ""
            }
            header={header}
          />
        );
      });
      return noticesData;
    } catch (error) {
      setErrMsg(error);
    }
  };

  if (errMsg) {
    uploadLog(window.location.href, "ERROR", errMsg);
    return (
      <Container>
        <CloseBtn onClick={onWebviewClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
              minHeight: "2.75rem",
              marginTop: "4px",
              marginRight: "1.1875rem",
            }}
            width="28"
            height="28"
            viewBox="0 0 28 28"
          >
            <g fill="none" fillRule="evenodd">
              <g fillRule="nonzero">
                <g>
                  <path
                    d="M0 0H28V28H0z"
                    transform="translate(-596 -8) translate(596 8)"
                  />
                  <path
                    fill="var(--text-color)"
                    d="M21.467 6.535c.466.467.466 1.05.116 1.517l-.116.117-5.717 5.833 5.833 5.717c.467.466.467 1.166 0 1.633-.466.467-1.05.467-1.516.117l-.234-.117L14 15.635 8.167 21.47c-.467.466-1.167.466-1.634 0-.466-.467-.466-1.05-.116-1.517l.116-.117 5.834-5.833-5.834-5.717c-.466-.466-.466-1.166 0-1.633.467-.467 1.05-.467 1.517-.117l.117.117L14 12.37l5.717-5.717c.583-.583 1.283-.583 1.75-.117z"
                    transform="translate(-596 -8) translate(596 8)"
                  />
                </g>
              </g>
            </g>
          </svg>
        </CloseBtn>
        <InternalError />
      </Container>
    );
  }
  return (
    <Container>
      <button
        id="backkeyTrigger"
        style={{ display: "none" }}
        onClick={onWebviewClose}
      ></button>
      <Shield>
        <Helmet>
          <title>KineMaster Notice</title>
        </Helmet>
        <AppBar
          style={{
            backgroundColor: "var(--bg-color)",
            position: "fixed",
            minHeight: "2.75rem",
            boxShadow: "none",
          }}
        >
          <Toolbar
            style={{
              minHeight: "2.75rem",
              marginTop: "4px",
              padding: "0px 1.1875rem",
            }}
          >
            {showClose ? (
              <IconButton
                edge="start"
                color="inherit"
                onClick={onWebviewClose}
                aria-label="close"
                style={{ padding: "0px", marginLeft: "0px" }}
                size="large"
              >
                <svg width="1.625rem" height="1.625rem" viewBox="0 0 26 26">
                  <g
                    fill="none"
                    fillRule="evenodd"
                    stroke="var(--text-color_sub1)"
                    strokeLinecap="round"
                    strokeWidth="2"
                  >
                    <path d="M7.757 13.243l8.486 8.486M16.242 4.757l-8.485 8.486" />
                  </g>
                </svg>
              </IconButton>
            ) : (
              <IconButton
                edge="start"
                color="inherit"
                aria-label="placeholder"
                style={{ padding: "0px", marginLeft: "0px" }}
                size="large"
              >
                <svg
                  width="1.625rem"
                  height="1.625rem"
                  viewBox="0 0 26 26"
                ></svg>
              </IconButton>
            )}
            <div className="notice-header" style={{ margin: "0px auto" }}>
              {header}
            </div>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
              style={{ padding: "0px", marginLeft: "0px" }}
              size="large"
            >
              <svg width="1.625rem" height="1.625rem" viewBox="0 0 26 26"></svg>
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className="header-size-element" />
        {notices ? renderNotices() : <LoadingBar />}
      </Shield>
    </Container>
  );
};

export default withStyles(styles)(NoticeList);
